import React from 'react';
import '../styles/LeftMain.css';
import Black from '../assets/Black.png';

const LeftMain = () => {
  return (
    <div className='section'>
      <div className="left-main-container">
        <div className="Black">
          <img src={Black} alt="black" className="Black" />
        </div>
        <p className='left-text'>
          Become the Ultimate NFT Champion and Mint your Collection
        </p>
        <p className='types'>
          Step into the future with Project Instinct and join the NFT revolution.
          Mint your choice of Ebooks, Art, Music, Podcasts, Courses ... Any digital file!
        </p>
      </div>
    </div>
  );
};

export default LeftMain;
